// extracted by mini-css-extract-plugin
module.exports = {"totalCounter":"total-counter_totalCounter__6G7Ww"};